import React, {useState} from "react";
import {Box, Button, Slider, Typography, useMediaQuery,} from "@mui/material";
import {styled} from "@mui/material/styles";
import {useTranslation} from "react-i18next";

const Separator = styled("div")(({theme}) => `
  height: ${theme.spacing(3)};
`);

// Function to map scaledValue to value
const getValueFromScaledValue = (scaledValue, marks) => {
    const mark = marks.find((mark) => mark.scaledValue === scaledValue);
    return mark ? mark.value : marks[0].value; // Default to the first mark's value if not found
};

// Function to snap the slider value to the nearest mark
const snapToNearestMark = (value, marks) => {
    const closestMark = marks.reduce((prev, curr) => {
        return Math.abs(curr.value - value) < Math.abs(prev.value - value) ? curr : prev;
    });
    return closestMark.value;
};

export default function NonLinearQuestion({
                                              data,
                                              addQuestion,
                                              deleteQuestionsAfterIndex,
                                              goToNextQuestion,
                                              isVisible,
                                              addToUpdateQuestions,
                                              deleteFromQuestionToUpdate,
                                          }) {
    const isMobile = useMediaQuery("(max-width:900px)");

    // Initialize sliderValue by mapping currentValue (scaledValue) to the corresponding value
    const [sliderValue, setSliderValue] = useState(
        getValueFromScaledValue(data.currentValue, data.marks)
    );

    const {t} = useTranslation();
    const language = localStorage.getItem("i18nextLng");

    // Function to map value to scaledValue
    const scale = (value) => {
        const mark = data.marks.find((mark) => mark.value === value);
        return mark ? mark.scaledValue : 0;
    };

    // Handle slider value changes
    const handleSliderChange = (event, newValue) => {
        // Snap the slider value to the nearest mark
        const snappedValue = snapToNearestMark(newValue, data.marks);

        deleteQuestionsAfterIndex(data);
        deleteFromQuestionToUpdate(data);
        setSliderValue(snappedValue); // Update the slider value in state
        console.log("Slider value (scaled):", scale(snappedValue));
    };

    // Handles the "Next" button click
    const handleNextClick = () => {
        if (data.required && (sliderValue === null || sliderValue === undefined)) {
            alert(t("This field is required."));
            return;
        }

        const scaledValue = scale(sliderValue);

        if (data && scaledValue >= 0 && scaledValue !== data.currentValue) {
            addToUpdateQuestions(data, scaledValue);
        }

        if (
            data.marks.some((mark) => mark.scaledValue === scaledValue) &&
            data?.question_object
        ) {
            addQuestion(data?.question_object);
        } else {
            goToNextQuestion();
        }

    };

    function handleSkipClick() {
        if (data?.associated_step_id === "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b") {
            if (data?.question_object) {

                addQuestion(data?.question_object);
            } else {
                // Otherwise, move to the next question
                goToNextQuestion(null, true);
            }
        } else {
            goToNextQuestion(null, true);
        }
    }

    return (
        <div style={{padding: "20px"}}>
            {/* Render question */}
            <Typography variant="subtitle1" sx={{mb: 2}}>
                {language === "fr" ? data?.question_fr : data.question}
            </Typography>
            <Box>
                {/* Slider */}
                <Slider
                    sx={{
                        width: isMobile ? "97%" : "98%",
                    }}
                    value={
                        sliderValue !== null && sliderValue !== undefined
                            ? sliderValue
                            : data.min
                    }
                    min={data.min}
                    max={data.max}
                    // step={null} // Disable step to allow snapping to marks
                    marks={data.marks}
                    valueLabelDisplay="auto" // Show value label only on hover or interaction
                    onChange={handleSliderChange}
                    aria-labelledby="non-linear-slider"
                />
                <Separator/>
            </Box>
            {/* Next Button */}


            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                {isVisible(data) && (
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{
                            height: "50px",
                            width: data?.associated_step_id !== "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b" ? "50%" : "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        onClick={handleNextClick}
                        disabled={sliderValue === null || sliderValue === undefined} // Disable if required fields are empty
                    >
                        {data?.last_step_question_2 ? t("finish") : t("next")}
                    </Button>
                )}
                {isVisible(data) && (
                    <Button
                        style={{
                            height: "50px",
                            width: "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        color="secondary"
                        variant="contained"
                        onClick={handleSkipClick}
                    >
                        {t("skip")}
                    </Button>
                )}
            </div>
        </div>
    );
}